/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SendEmailToPatientDto = {
    referralId: string;
    subject: string;
    message: string;
    patientEmail: string;
    templateKey: SendEmailToPatientDto.templateKey;
}

export namespace SendEmailToPatientDto {

    export enum templateKey {
        INVITE_TO_RESCHEDULE = 'INVITE_TO_RESCHEDULE',
        SCHEDULED_MEETING_CONFIRMATION = 'SCHEDULED_MEETING_CONFIRMATION',
        INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
        NEWSLETTER_INVITATION = 'NEWSLETTER_INVITATION',
        SITE_EMPLOYEE_INVITATION = 'SITE_EMPLOYEE_INVITATION',
        RESET_PASSWORD = 'RESET_PASSWORD',
        NEW_APPOINTMENT = 'NEW_APPOINTMENT',
        NEW_REFERRAL = 'NEW_REFERRAL',
        WEEKLY_NEW_REFERRAL = 'WEEKLY_NEW_REFERRAL',
        PATIENT_APPOINTMENT_REMINDER = 'PATIENT_APPOINTMENT_REMINDER',
        PATIENT_NEW_REFERRAL = 'PATIENT_NEW_REFERRAL',
        FOLLOWUP_ON_CLINLIFE_REGISTRATION = 'FOLLOWUP_ON_CLINLIFE_REGISTRATION',
        FINAL_ATTEMPT_NOTICE = 'FINAL_ATTEMPT_NOTICE',
        RECONTACTED_PATIENT_NOTIFICATION = 'RECONTACTED_PATIENT_NOTIFICATION',
        PATIENT_CONTACT_CONFIRMATION = 'PATIENT_CONTACT_CONFIRMATION',
        POST_SCREEN_SURVEY = 'POST_SCREEN_SURVEY',
        LINK_TO_UPLOAD_EHR = 'LINK_TO_UPLOAD_EHR',
    }


}
